<template>
  <modal :state="state" :index="index" @toggle-modal="cancel" :should-cancel-on-outside-click="false" prevent-esc class="xl">
    <div slot="body">
      <h3 class="modal-title">
        <slot name="title">{{ headerText }}</slot>
      </h3>
      <p>
        <slot name="subtitle">{{ descriptionText }}</slot>
      </p>

      <scroll-area class="max rule-set">
        <div v-if="ruleSet" class="col">
          <div v-if="hasContextText" class="align-left py-1">
            <strong>
              <slot name="context-text">{{ contextText }}</slot>
            </strong>
          </div>

          <slot name="edit-rule-set" :ruleSet="ruleSet" :parent="parent">
            <edit-conditional-rule-set
              :rule-set="ruleSet"
              :key="ruleSet.client_id"
              :parent="parent"
              :conditional-rule-options="conditionalRuleOptions"
              :matchFormFields="matchFormFields"
              :disallow-multiple-sets="disallowMultipleSets"
            >
              <template #rule-options="slotProps"><slot name="rule-options" :rule="slotProps.rule"></slot></template>
            </edit-conditional-rule-set>
          </slot>
        </div>
      </scroll-area>

      <br>

      <div v-if="showPreview" class="rule-preview">
        <h5>Preview</h5>

        <div class="condition-block scroll-area">
          <p>If <span v-html="ruleSet.toHtmlString(form)"></span></p>
        </div>
      </div>

      <flash-attribute-messages v-if="shouldValidate && !isComplete" :messages="flashMessages"></flash-attribute-messages>

      <div class="cta">
        <button class="btn block red outline" @click.prevent="cancel">Cancel</button>
        <button class="btn block green" @click.prevent="handleSave">
          <slot name="config-complete-text">{{ configCompleteText }}</slot>
        </button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";
  import EditConditionalRuleSet from "./editConditionalRuleSet.vue"
  import HoldChangesUntilSaveMixin from "../../mixins/holdChangesUntilSaveMixin";
  import ModalComponentMixin from "../../mixins/modalComponentMixin";
  import ConditionalDisplayModalWrapperMixin from "~/mixins/conditional-display-modal-wrapper-mixin";
  import FlashAttributeMessages from "../flash/flash-attribute-messages.vue";
  import {BooleanHelper} from "~/helpers/booleanHelper";

  export default Vue.extend({
    components: {EditConditionalRuleSet,FlashAttributeMessages},
    mixins: [
      HoldChangesUntilSaveMixin,
      ModalComponentMixin,
      ConditionalDisplayModalWrapperMixin,
    ],
    props: {
      configuringConditionalStep: {
        type: Boolean,
        default: false
      },
      matchFormFields: {
        type: Boolean,
        default: false
      },
      form: {
        type: Object,
        default: null
      },
      disallowMultipleSets: {
        type: Boolean,
        default: false,
      },
      hidePreview: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      this.holdChangesModel = this.ruleSet;
      this.holdChangesParentModel = this.parent;
    },
    computed: {
      isComplete(): boolean {
        return this.ruleSet.isComplete;
      },
      headerText() {
        return this.header || (this.ruleSet.parent ? 'Edit' : 'Add') + ' Conditional Rule';
      },
      descriptionText() {
        return this.description || 'Create your own conditional request';
      },
      hasContextText(): boolean {
        return this.contextText.length > 0;
      },
      showPreview(): boolean {
        return BooleanHelper.isStrictFalse(this.hidePreview);
      },
    },
    methods: {
      handleSave(event): void {
        if (this.configuringConditionalStep) {
          this.saveAndEmitComplete();
        } else {
          this.save(event);
        }
      },
      saveAndEmitComplete() {
        if (!this.isComplete) {
          this.shouldValidate = true;
          return;
        }
        if (!this.holdChangesModel.isAttached) {
          this.holdChangesModel.attachToParent(this.holdChangesParentModel);
        }
        this.holdChangesModel.triggerChanges = true;
        this.$emit('finishedSettingCondition');
      }
    },
    watch: {
      ruleSet: function(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.holdChangesModel = newVal
        }
      }
    }
  });
</script>
